<script setup>
import { onMounted, onUnmounted, computed } from 'vue';
import { useStore } from 'vuex';

const store = useStore();
const idle = computed(() => store ? store.state.idle : null);
const idle_time_duration = computed(() => 30000);
const traffic_record = computed(() => store.state.trafficRecordComponent.traffic_record);
const userId = computed(() => store.state.trafficRecordComponent.user_id);
const phase_id = computed(() => store.state.trafficRecordComponent.phase_id);

onMounted(() => {
  store.dispatch('idle/fetchIdleTime')
  .then(function () {
    activityTime();
  })
});

onUnmounted(() => {
  store.dispatch('idle/clear');
  document.onload = stopTimer;
  document.onmousemove = stopTimer;
  document.onmousedown = stopTimer; // touchscreen presses
  document.ontouchstart = stopTimer;
  document.onclick = stopTimer; // touchpad clicks
  document.onkeypress = stopTimer;
  document.addEventListener('scroll', stopTimer, true);

  function stopTimer() {
    clearTimeout(window.time_duration);
  }
});

const activityTime = () => {
  resetTimer();
  document.onmousemove = resetTimer;
  document.onmousedown = resetTimer; // touchscreen presses
  document.ontouchstart = resetTimer;
  document.onclick = resetTimer; // touchpad clicks
  document.onkeypress = resetTimer;
  document.addEventListener('scroll', resetTimer, true);

  let ActiveDuration = idle_time_duration.value - 10000;
  clearTimeout(window.active_time_duration);
  window.active_time_duration = setTimeout(active, ActiveDuration);

  function active () {
    if (!store.state.idle.isIdle) {
      clearTimeout(window.active_time_duration);
      window.active_time_duration = setTimeout(active, ActiveDuration);

      store.dispatch('idle/checkStatus', {
        user_id: userId.value,
        phase_id: phase_id.value,
      });
    }
  }

  function idle() {
    clearTimeout(window.active_time_duration);
    if (!store.state.idle.isIdle) {
      store.dispatch('idle/broadcastUserIdle', {
        user_id: userId.value,
        phase_id: phase_id.value,
      });
    }
  }

  function resetTimer() {
    if (!store.state.idle.isIdle) {
      clearTimeout(window.time_duration);
      window.time_duration = setTimeout(idle, idle_time_duration.value);
    }
  }
};

const continueActivity = () => {
  reload();
  store.dispatch('idle/broadcastUserActivate', {
    user_id: userId.value,
    phase_id: phase_id.value,
    traffic_record_id: traffic_record.value.id,
    queue_id: traffic_record.value.queue.id
  }).then(function () {
    activityTime();
  });
}

const reload = () => {
  window.location.reload();
}

</script>

<template>
  <div class="backdrop"  v-if="idle && idle.isIdle">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-10 col-lg-8">
          <div class="card p-3">
            <div class="card-body row justify-content-center">
              <div class="col-md-1">
                <img width="50" src="@/assets/images/animated-traffic-light.gif" />
              </div>
              <div class="offset-1 col-md-6">
                <h3>{{ idle.message }}</h3>
                <p v-show="idle.message == 'User is inactive.'">You been Idle for {{ idle_time_duration /60000 }} minute(s), Please click button to continue working on this phase.</p>
                <p v-show="idle.message == 'User is active.'">You can now continue working on this phase.</p>
                <p v-show="idle.type == 'error'">The record you been working is not assigned to you anymore. Please reload the page.</p>
                <button v-show="idle.message == 'User is inactive.' && idle.isIdle" @click="continueActivity" class="btn btn-secondary rounded-pill waves-effect waves-light">
                  <i class="mdi mdi-refresh"></i>
                  Continue
                </button>
                <button v-show="idle.type == 'error'" @click="reload" class="btn btn-secondary rounded-pill waves-effect waves-light">
                  <i class="mdi mdi-refresh"></i>
                  Reload
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.backdrop {
  position: absolute;
  min-width: 100%;
  max-width: 100%;
  z-index: 9999;
  background-color: rgba(0,0,0,0.5);
  height: 100%;
  left: 0;
  top: 0;
}
.backdrop .container {
  position: absolute;
  transform: translate(-50%, -50%);
  left: 50%;
  top: 40%;
}
</style>
